module.exports = __webpack_public_path__ + "img/cadenas2.89085bf2.svg";